var map = {
	"./360.svg": "8c6e",
	"./360se.svg": "LWPA",
	"./LBBROWSER.svg": "38pL",
	"./Mac.svg": "FcTC",
	"./QQBrowser.svg": "iJLh",
	"./Windows 10.svg": "7QYS",
	"./Windows 7.svg": "qr7B",
	"./Windows 8.svg": "zImy",
	"./android.svg": "GifN",
	"./baidu.svg": "sKJP",
	"./chrome.svg": "nkG5",
	"./chromium.svg": "Zqu6",
	"./crios.svg": "Bkpt",
	"./debian.svg": "E9ds",
	"./edge.svg": "Vv78",
	"./fedora.svg": "FmCP",
	"./firefox.svg": "9ywc",
	"./ie.svg": "Pb25",
	"./ie10.svg": "m5ko",
	"./ie11.svg": "A1vJ",
	"./ie8.svg": "vp5s",
	"./ie9.svg": "EaLP",
	"./ipad-o.svg": "wggr",
	"./ipad.svg": "+YGk",
	"./iphone-o.svg": "7/xX",
	"./iphone.svg": "ld0e",
	"./linux.svg": "vu0M",
	"./macos.svg": "RoFt",
	"./maxthon.svg": "HyWl",
	"./opera.svg": "82/T",
	"./opera15.svg": "6cyt",
	"./rocket.svg": "FodQ",
	"./safari.svg": "soHw",
	"./sogou.svg": "z2ox",
	"./su-android.svg": "10FV",
	"./superheroe.svg": "yBXV",
	"./ubuntu.svg": "qY0Z",
	"./ucweb.svg": "WDkq",
	"./wechat.svg": "wG2o",
	"./windows.svg": "vURw",
	"./windows_phone.svg": "9Byh",
	"./windows_vista.svg": "NJvm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kToh";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uas nonrecursive \.svg$
// module id = kToh
// module chunks = 16